module.exports = __webpack_public_path__ + "img/google-play-badge.c97d6b38.png";